import BoxInfoCard from './boxInfoCard.container'
export default BoxInfoCard